import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CustomerReportPage from './components/CustomerReportPage';

export default function App() {
  return (
    <Routes>
      <Route path="/customer-report" element={<CustomerReportPage />} />
      <Route path="*" element={<Navigate to="/customer-report" replace />} />
    </Routes>
  );
}
